import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './search/search.component';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { RecipeComponent } from './recipe/recipe.component';
import { LoginComponent } from './login/login.component';
import { EditRecipeComponent } from './edit-recipe/edit-recipe.component';
import { AuthGuardService } from './auth-guard.service';
import {AutosizeModule} from 'ngx-autosize';


const appRoutes: Routes = [
  { path: 'search', component: SearchComponent },
  { path: '', component: SearchComponent },
  { path: 'recipe/:id', component: RecipeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'edit-recipe/:id', component: EditRecipeComponent, canActivate: [AuthGuardService]}
]


@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    RecipeComponent,
    LoginComponent,
    EditRecipeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(appRoutes),
    AngularFontAwesomeModule,
    AutosizeModule
  ],
  providers: [
    AuthGuardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
